import EditColumn from "../components/EditColumn";
import { connect } from "react-redux";
import { All, KeyValue, Query } from "../interfaces";
import { Dispatch } from "react";
import * as actions from "../common/actions";

function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    resetState: (state: Query) => {
      dispatch(actions.resetState(state));
    },
    updateUi: (
      filter: string,
      value: string | string[] | KeyValue[] | undefined,
    ) => {
      dispatch(actions.updateUi(filter, value));
      dispatch(actions.searchPush());
    },
    updateFilters: (filter: string, value: string | string[]) => {
      dispatch(actions.updateFilter(filter, value));
      dispatch(actions.searchPush());
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(EditColumn);
